import React from 'react';

import * as styles from './MoveCost.module.scss';

import { ReactComponent as CandySVG } from '../images/candy.svg';
import { ReactComponent as FuelSVG } from '../images/fuel.svg';
import { CURRENCY } from '../../../data/characters'

interface MoveCostProps {
  type: string,
  amount: number,
  className?: string
}

const MoveCost : React.FC<MoveCostProps> = ({ className, type, amount }) => {
  const it = new Array(amount).fill(0);

  return (
    <ul className={` ${styles.movecost} ${className}` }>
      {
        it.map((v, index) => {
          if (type === CURRENCY.CANDY) {
            return <li key={index}><CandySVG/></li>
          }
          if (type === CURRENCY.FUEL) {
            return <li key={index}><FuelSVG/></li>
          }

          return null;
        })
      }
    </ul>
  )
};

export default React.memo(MoveCost);
